import { useCallback, useEffect, useMemo, useRef } from "react";
export const useDebouncedCallback = (fn, deps, delay = 250) => {
    const timerRef = useRef(null);
    const currentFn = useMemo(() => fn, deps);
    useEffect(() => () => {
        if (timerRef.current)
            clearTimeout(timerRef.current);
        timerRef.current = null;
    }, [currentFn, delay]);
    return useCallback(() => {
        if (timerRef.current === null) {
            timerRef.current = setTimeout(() => (timerRef.current = null), delay);
            currentFn();
        }
        else {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                timerRef.current = null;
                currentFn();
            }, delay);
        }
    }, [currentFn, delay]);
};
